export default __webpack_public_path__ + "static/media/avalanche.a3f3731d.svg";